import type { CategorySection } from "./listingCategoryFields/types"
import { genericSections } from "./listingCategoryFields/sharedOptions"
import { getSectionsFromPropertyFiles } from "./listingCategoryFields/sections"

export * from "./listingCategoryFields/types"
export * from "./listingCategoryFields/constants"
export * from "./listingCategoryFields/utils"

export function getCategorySections(formTypeKey: string): CategorySection[] {
  if (!formTypeKey) return []
  return getSectionsFromPropertyFiles()[formTypeKey] ?? genericSections
}
